export default "<div class=\"row\">\r\n  <div class=\"col-12 col-md-6\">\r\n    <app-settings></app-settings>\r\n  </div>\r\n</div>\r\n"